import addMount from "../../core/addMount";
import ShareButtons from "./share-buttons.entry";

addMount({ appName: "share-buttons", app: ShareButtons });
